import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ShieldX } from "lucide-react";
import { Routes } from "@/router/routes";
import { useLogout } from "@/api/auth.api";
import { useTenantStore } from "@/store/tenant/tenant.store";

export const NoRoleAssigned = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { mutate: logout } = useLogout();
    const { clearTenantData } = useTenantStore();

    const handleChangeTenant = () => {
        clearTenantData();
        navigate(`/${Routes.TenantSelection}`);
    };

    const handleLogout = () => {
        logout();
    };

    return (
        <div className="flex items-center justify-center min-h-screen p-4">
            <Card className="w-full max-w-md">
                <CardHeader className="text-center">
                    <div className="flex justify-center mb-4">
                        <ShieldX className="h-16 w-16 text-muted-foreground" />
                    </div>
                    <CardTitle className="text-xl">{t("noRoleAssigned.title")}</CardTitle>
                    <CardDescription className="text-center">
                        {t("noRoleAssigned.description")}
                    </CardDescription>
                </CardHeader>
                <CardContent className="space-y-4">
                    <Button onClick={handleChangeTenant} className="w-full" variant="outline">
                        {t("noRoleAssigned.changeTenant")}
                    </Button>
                    <Button onClick={handleLogout} className="w-full" variant="destructive">
                        {t("noRoleAssigned.logout")}
                    </Button>
                </CardContent>
            </Card>
        </div>
    );
};
